import { Company } from "#modules/company/infra/Company.dto";
import { Icon } from "#shared/icons/Icon";
import { Grid } from "#shared/view/components/Grid";
import { Button } from "#shared/view/designSystem/Button";
import { Data } from "#shared/view/designSystem/Data";

export const CompanyInfoDetails = ({
  company,
  onEdit,
}: {
  company: Company;
  onEdit: () => void;
}) => {
  return (
    <>
      <Grid gap="lg" mt="sm">
        <Grid.Col span={4}>
          <Data label="Nom de l'entreprise" value={company.name} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Data label="Adresse" value={company.address.street} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Data label="Code postal" value={company.address.zipCode} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Data label="Ville" value={company.address.city} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Data label="SIRET" value={company.siret} />
        </Grid.Col>
        <Grid.Col span={4}>
          <Data label="IBAN" value={company.iban} />
        </Grid.Col>
      </Grid>
      <Button variant="outline" icon={<Icon name="edit" />} onClick={onEdit} mt="sm">
        Modifier
      </Button>
    </>
  );
};
